/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAppDispatch } from "app/hooks";
import { setNftDetails, setNftMetadata, setNftToken } from "components/Popup/popupSlice";
import API from "libs/api";
import APIMoralis from "libs/apiMoralis";
import React, { Fragment, useEffect, useState } from "react";

type IProps = {
    item: any,
}
export default function NftItem(props: IProps) {
    const { item } = props;

    const dispatch = useAppDispatch()

    const [meta, setMeta] = useState<any>();
    const [pending, setPending] = useState(false);
    const api = new API();
    const apiMoralis = new APIMoralis();

    const getMetaData = async (uri) => {
        setPending(true);
        try {
            await api.getMetadata(uri).then(
                (result) => {
                    setMeta(result);
                },
                (error) => {
                    console.log(error!.message);
                    try {
                        apiMoralis.updateMetadata(item.token_address, item.token_id);
                    } catch (e) {

                    }
                }
            )
        } catch (e) {
            console.log(e);
        } finally {
            setPending(false);
        }
    }

    useEffect(() => {
        if (item.token_uri && !pending) {
            getMetaData(item.token_uri)
        }
    }, [item])

    const thumb = meta ? meta.image || meta.thumb : '/assets/img/no-preview.png';
    const name = meta ? meta.name || meta.title : item.name;

    const handleClick = () => {
        if (item) {
            dispatch(setNftToken(item));
            dispatch(setNftMetadata(meta));
            dispatch(setNftDetails(true));
        }
    }

    return (
        <Fragment>
            <Box
                sx={{
                    width: '100%',
                    borderRadius: '10px',
                    background: '#3E4357',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >
                <Box
                    sx={{
                        width: '100%',
                        aspectRatio: '1/0.98',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& img': {
                            width: '100%',
                            borderRadius: '10px 10px 0px 0px',
                            overflow: 'hidden',
                            objectFit: 'cover',
                            background: '#888888',

                        }
                    }}
                >
                    {!pending ? <img src={thumb} alt='' aria-label='' /> : <CircularProgress size={20} />}
                </Box>

                <Typography
                    sx={{
                        textAlign: 'center',
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#ffffff',
                        pt: 1.5,
                    }}
                >
                    {name}
                </Typography>
                <Typography
                    sx={{
                        textAlign: 'center',
                        fontSize: 10,
                        fontWeight: 300,
                        color: '#ffffff',
                        pb: 1.5,
                    }}
                >
                    TokenID:{item.token_id}
                </Typography>
            </Box>
        </Fragment>
    );
}